import { render, staticRenderFns } from "./Learners.vue?vue&type=template&id=20a861b1&scoped=true&"
import script from "./Learners.vue?vue&type=script&lang=js&"
export * from "./Learners.vue?vue&type=script&lang=js&"
import style0 from "./Learners.vue?vue&type=style&index=0&id=20a861b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a861b1",
  null
  
)

export default component.exports